import React from "react";
import { Link } from "react-router-dom";
import styles from "./Portfolio.module.css";

const Portfolio = () => {
  return (
    <>
      <div className={styles.portfolioSection} id="portfolio">
        <h2 className={styles.portfolioHeading}>Why Choose FirstLand</h2>
        <div className={styles.dividerWrapper}>
          <div className={styles.divider}></div>
        </div>

        <div
          className={styles.portfolioGrid}
          data-aos="fade-down"
          data-aos-delay="600"
        >
          <div className={styles.productCard}>
            <div className={styles.cardContent}>
              <h4 className={styles.cardTitle}>
                Boost Your Real Estate Business
              </h4>
              <p className={styles.cardDescription}>
                FirstLand is designed to elevate your real estate career by
                giving you the tools to effectively showcase your expertise and
                listings. Our platform provides a full suite of professional
                services that allow you to seamlessly manage properties, engage
                clients, and enhance your visibility in the market.
              </p>
              <div className="flex justify-center my-4">
                <Link to="/contact" className={styles.scheduleDemoButton}>
                  Schedule Demo
                  <svg
                    className={styles.buttonIcon}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className={styles.productCard}>
            <div className={styles.cardContent}>
              <h4 className={styles.cardTitle}>
                AI-Driven Solutions for Professionals
              </h4>
              <p className={styles.cardDescription}>
                Qur AI-powered tools provide predictive analytics, lead
                generation, and automated support, helping you work more
                efficiently and close deals faster. Take advantage of
                cutting-edge technology to get ahead in a competitive market.
              </p>
              <div className="flex justify-center my-4">
                <Link to="/contact" className={styles.scheduleDemoButton}>
                  Schedule Demo
                  <svg
                    className={styles.buttonIcon}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className={styles.productCard}>
            <div className={styles.cardContent}>
              <h4 className={styles.cardTitle}>Multi Property Management</h4>
              <p className={styles.cardDescription}>
                FirstLand offers robust marketing automation tools, personalized
                email campaigns, and lead generation solutions to ensure you
                reach your target audience. Scale your business with technology
                designed for real estate professionals.
              </p>
              <div className="flex justify-center my-4">
                <Link to="/contact" className={styles.scheduleDemoButton}>
                  Schedule Demo
                  <svg
                    className={styles.buttonIcon}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          <div className={styles.productCard}>
            <div className={styles.cardContent}>
              <h4 className={styles.cardTitle}>
                Automated Marketing and Lead Generation
              </h4>
              <p className={styles.cardDescription}>
                OFirstLand offers robust marketing automation tools,
                personalized email campaigns, and lead generation solutions to
                ensure you reach your target audience. Scale your business with
                technology designed for real estate professionals.
              </p>
              <div className="flex justify-center my-4">
                <Link to="/contact" className={styles.scheduleDemoButton}>
                  Schedule Demo
                  <svg
                    className={styles.buttonIcon}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
